import DashboardLayout from 'src/pages/Layout/DashboardLayout.vue';
import AuthLayout from 'src/pages/Authentication/AuthLayout.vue';
import { canConfigurePos } from 'src/util/posBeta';
import { isCampaignsBetaCompany } from 'src/util/campaignsBeta';
import { isSmsBetaCompany } from 'src/util/smsBeta';
import { isAffiliatesBetaCompany } from 'src/util/affiliatesBeta';
import { isPassesBetaCompany } from 'src/util/passesBeta';
import { getPreferredBookingsPath, stripViewFilterParams } from 'src/util/bookingsView';
import { resolveHomePath } from 'src/util/postSignIn';
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue';
import Unauthorized from 'src/pages/GeneralViews/UnauthorizedPage'

//Authentication
const Login = () =>
  import(/* webpackChunkName: "pages" */ 'src/pages/Authentication/Login.vue');
const ForgotPassword = () =>
  import(/* webpackChunkName: "pages" */ 'src/pages/Authentication/ForgotPassword.vue');
const AcceptInvite = () =>
  import(/* webpackChunkName: "pages" */ 'src/pages/Authentication/AcceptInvite.vue');

//Bookings
import Bookings from '@/pages/Bookings/Bookings/Bookings.vue'
import BookingSlots from "@/pages/Bookings/BookingSlots"
import ResourceCalendarPage from "@/pages/Bookings/ResourceCalendarPage"
import KanbanPage from "@/pages/Bookings/KanbanPage"
import ScheduleList from "@/pages/Schedules/ScheduleList";
import PaymentGateways from "@/pages/Purchases/PaymentSettings/PaymentSettings";
import PaymentPagesList from "@/pages/Purchases/PaymentPages/PaymentPagesList";
import PaymentPageEditor from "@/pages/Purchases/PaymentPages/PaymentPageEditor";
import RequestFormsList from "@/pages/Bookings/RequestForms/RequestFormsList";
import RequestFormEditor from "@/pages/Bookings/RequestForms/RequestFormEditor";

//Purchases
import Transactions from "@/pages/Purchases/Transactions/Transactions";
import TransactionDetails from "@/pages/Purchases/Transactions/TransactionDetails";
import NewTransaction from "@/pages/Purchases/Transactions/NewTransaction";
import GiftCards from "@/pages/Purchases/GiftCards/GiftCards";
import GiftCardType from "@/pages/Purchases/GiftCards/GiftCardType";
import Passes from "@/pages/Purchases/Passes/Passes";

// Marketing
import Affiliates from "@/pages/Marketing/Affiliates.vue";


// Games
import EditGame from 'src/pages/Games/GameSetup/EditGame'
import GameInstance from 'src/pages/Games/GameHistory/GameInstance'
import GameInstances from 'src/pages/Games/GameHistory/GameInstances'
import GameSetup from 'src/pages/Games/GameSetup/GameSetup'
import GameTracker from 'src/pages/Games/GameTracker/GameTracker'
import GameTrackerSelect from "@/pages/Games/GameTracker/GameTrackerSelect";
import GameTrackerSettingsTemplate from "@/pages/Games/GameTrackerSettings/GameTrackerSettingsTemplate"
// import GameTrackerLive from 'src/pages/Games/GameTrackerV2/GameTrackerLive'

//Checklists
import ChecklistEditor from "@/pages/Checklists/ChecklistEditor";
import Clues from 'src/pages/Games/Clues/Clues'
import ClueDisplay from 'src/pages/Games/Clues/ClueDisplay'
import GameSelect from 'src/pages/Games/Clues/GameSelect'
import GameSelectGMView from 'src/pages/Games/Clues/GameSelectGMView'
import ConfigureClues from "@/pages/Games/Clues/ConfigureClues";
import DisplayConfiguration from "@/pages/Games/Clues/DisplayConfiguration";
import ClueHistory from "@/pages/Games/Clues/ClueHistory";



//Mail
import AutomatedEmails from "@/pages/Mail/AutomatedEmails/AutomatedEmails";
import PreviewEmail from "@/pages/Mail/AutomatedEmails/PreviewEmail";

//Settings
import UserManagement from '@/pages/Settings/UserManagement/UserManagement'
import CompanySettings from 'src/pages/Settings/CompanySettings'
import MyProfile from 'src/pages/Settings/MyProfile'
import BillingPage from "@/pages/Settings/Billing/BillingPage";
import CustomFieldsLibrary from "@/pages/Settings/CustomFields/CustomFieldsLibrary";

//Surveys
import Surveys from 'src/pages/Surveys/Surveys'


// Waivers
import Waivers from 'src/pages/Waivers/Waivers.vue';
import WaiverTemplate from 'src/pages/Waivers/WaiverTemplate';

//customers
import PlayerInfo from 'src/pages/Players/PlayerInfo'
import Players from "@/pages/Players/Players";

// Dashboard pages
import GameDashboards from '@/pages/Dashboard/Analytics/GameDashboards'
import GameStats from '@/pages/Dashboard/Analytics/GameStats'
import Leaderboard from '@/pages/Dashboard/Leaderboards/Leaderboard'
import LeaderboardSettings from "@/pages/Dashboard/Leaderboards/LeaderboardSettings";
import ReportBuilder from "@/pages/Dashboard/Reports/ReportBuilder";
import NewReport from "@/pages/Dashboard/Reports/NewReport";
import ViewDashboards from "@/pages/Dashboard/Dashboards/ViewDashboards";

//Photo pages
import TakePhotos from "@/pages/Photos/TakePhotos";
import PhotoSettingsTemplate from "@/pages/Photos/PhotoSettingsTemplate";

import Changelog from "@/pages/Changelog/Changelog";
import StartNewForm from "@/pages/Games/GameTracker/StartNewForm";
import GroupSettings from "@/pages/Settings/GroupSettings/GroupSettings";
import Checklists from "@/pages/Checklists/Checklists";
import ChecklistHistory from "@/pages/Checklists/ChecklistHistory";
import ActiveChecklist from "@/pages/Checklists/ActiveChecklist";
import ChecklistInstance from "@/pages/Checklists/ChecklistInstance";
import EditReport from "@/pages/Dashboard/Reports/EditReport";
import GeneratedReport from "@/pages/Dashboard/Reports/GeneratedReport";
import CreateSchedule from "@/pages/Schedules/CreateSchedule";
import EditSchedule from "@/pages/Schedules/EditSchedule";
import EditSurvey from "@/pages/Surveys/EditSurvey";
import Migration from "@/pages/Settings/Migration/Migration";
import MigrationLog from "@/pages/Settings/Migration/MigrationLog";
import SurveyHistory from "@/pages/Surveys/SurveyHistory";
import SurveyResponse from "@/pages/Surveys/SurveyResponse";
import SurveyQuestionResponses from "@/pages/Surveys/SurveyQuestionResponses";
import PhotoOverlays from "@/pages/Photos/PhotoOverlays";
import UserRoles from "@/pages/Settings/UserManagement/UserRoles";
import EditRole from "@/pages/Settings/UserManagement/EditRole";
import EventLogs from "@/pages/Settings/EventLogs/EventLogs";
import ApiRequests from "@/pages/Settings/ApiRequests/ApiRequests";
import ActiveCarts from "@/pages/Purchases/ActiveCarts";
import InventoryManagement from "@/pages/Purchases/InventoryManagement";
import PromoCodes from "@/pages/Purchases/PromoCodes/PromoCodes";
import EditDashboard from "@/pages/Dashboard/Dashboards/EditDashboard";
import ChangelogLegacy from "@/pages/Changelog/ChangelogLegacy";
import TicketDetails from "@/pages/Changelog/TicketDetails";
import DashboardDisplay from "@/pages/Dashboard/Dashboards/DashboardDisplay";
import TicketList from "@/pages/Bookings/Tickets/TicketList";
import BookingRequests from "@/pages/Bookings/Requests/BookingRequests";
import ProjectList from "@/pages/ProjectManagement/Projects/ProjectList";
import ProjectDetails from "@/pages/ProjectManagement/Projects/ProjectDetails";
import ProjectTicket from "@/pages/ProjectManagement/Projects/ProjectTicket";
import WaiverConfigurationList from "@/pages/Waivers/WaiverConfigurationList";
import CustomEmailLanding from "@/pages/Mail/CustomEmails/CustomEmailLanding";
import PaymentList from "@/pages/Purchases/Payments/PaymentList";
import EmailTemplateTypes from "@/pages/Mail/CustomEmails/EmailTemplateTypes";
import EmailTemplateBuilder from "@/pages/Mail/CustomEmails/EmailTemplateBuilder";
import EmailAutomationBuilder from "@/pages/Mail/CustomEmails/EmailAutomationBuilder";
import Campaigns from "@/pages/Mail/CustomEmails/Campaigns";
import EditCampaign from "@/pages/Mail/CustomEmails/EditCampaign";
import CampaignReport from "@/pages/Mail/CustomEmails/CampaignReport";
import TimeTrackerLogs from "@/pages/ProjectManagement/TimeTracking/TimeTrackerLogs";
import OnboardingWizard from "@/pages/Wizard/OnboardingWizard";
import EmailDomainSettings from "@/pages/Mail/Settings/EmailDomainSettings";
import SMSSettings from "@/pages/Mail/SMS/SMSSettings";
import MessagingLogs from "@/pages/Mail/Logs/MessagingLogs";
import AnnouncementsPage from "@/pages/Announcements/AnnouncementsPage";
import BookingSiteSettingsList from "@/pages/Bookings/BookinSiteSettings/BookingSiteSettingsList";
import BookingSiteTemplateEditor from "@/pages/Bookings/BookinSiteSettings/BookingSiteTemplateEditor";

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  meta: { displayName: 'Authentication' },
  children: [
    {
      path: '/login',
      name: 'Login',
      meta: { displayName: 'Login' },
      component: Login
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      meta: { displayName: 'Forgot password' },
      component: ForgotPassword
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      meta: { displayName: 'Reset password' },
      component: ForgotPassword
    },
    {
      path: '/accept-invite',
      name: 'AcceptInvite',
      meta: { displayName: 'Accept invite' },
      component: AcceptInvite
    }
  ]
};

let dashboardMenu = {
  path: '/dashboard',
  component: DashboardLayout,
  redirect: '/dashboard/games',
  name: 'Dashboards',
  meta: { requiresAuth: true, displayName: 'Dashboards' },
  children: [
    {
      // Retired page (2026-08-23): the old main dashboard predates custom dashboards and had no
      // in-app links left, only bookmark traffic. Redirect keeps those bookmarks working.
      path: '/dashboard/main',
      redirect: '/dashboards'
    },
    {
      // Retired page (2026-11-02, OTC-3138): the old transactions dashboard had no in-app links
      // left. Redirect instead of falling through to NotFound, which clears localStorage.
      path: '/dashboard/bookings',
      redirect: '/dashboards'
    },
    {
      path: '/dashboards',
      name: 'Dashboard Display',
      meta: { displayName: 'Dashboards' },
      components: { default: DashboardDisplay }
    },
    {
      path: '/dashboards/settings',
      name: 'Dashboard Settings',
      meta: { displayName: 'Dashboard Settings' },
      components: { default: ViewDashboards }
    },
    {
      path: '/dashboards/edit',
      name: 'Edit Dashboard Settings',
      meta: { displayName: 'Dashboard Settings' },
      components: { default: EditDashboard }
    },
    {
      path: '/dashboard/games',
      name: 'Event Dashboards',
      meta: { displayName: 'Dashboards' },
      components: { default: GameDashboards }
    },
    {
      path: '/dashboard/game/analytics',
      name: 'Analytics',
      meta: { displayName: 'Analytics' },
      components: { default: GameStats }
    },
    {
      path: '/dashboard/game/leaderboard',
      name: 'Leaderboard',
      meta: { displayName: 'Leaderboards' },
      components: { default: Leaderboard }
    },
    {
      path: '/dashboard/game/leaderboard/settings',
      name: 'Leaderboard Settings',
      meta: { displayName: 'Leaderboard Settings' },
      components: { default: LeaderboardSettings }
    },
    {
      path: '/reports',
      name: 'Report Builder',
      meta: { displayName: 'Reports' },
      components: { default: ReportBuilder }
    },
    {
      path: '/reports/new',
      name: 'New Report',
      meta: { displayName: 'Reports' },
      components: { default: NewReport }
    },
    {
      path: '/reports/edit',
      name: 'Edit Report',
      meta: { displayName: 'Reports' },
      components: { default: EditReport }
    },
    {
      path: '/reports/run',
      name: 'Run Report',
      meta: { displayName: 'Reports' },
      components: { default: GeneratedReport }
    }
  ]
};

let bookingsMenu = {
  path: '/bookings',
  component: DashboardLayout,
  // Route the bare /bookings entry straight to the user's preferred view using
  // the cached booking_page_mode, instead of always landing on /bookings/list
  // (which mounts the heavy list page and double-loads before bouncing). Falls
  // back to /bookings/list on a cold cache (first-ever load); the list page
  // then caches the mode so subsequent visits route directly. Per-view filter
  // params are stripped so one view's filters can't leak onto another view.
  redirect: to => ({ path: getPreferredBookingsPath() || '/bookings/list', query: stripViewFilterParams(to.query) }),
  name: 'Bookings',
  meta: { requiresAuth: true, displayName: 'Bookings' },
  children: [
    {
      path: '/bookings/transactions/new',
      name: 'New Transaction',
      meta: { displayName: 'Bookings' },
      components: { default: NewTransaction }
    },
    {
      path: '/bookings/list',
      name: 'Booking List',
      meta: { displayName: 'Bookings' },
      components: { default: Bookings }
    },
    {
      path: '/bookings/tickets',
      name: 'Tickets',
      meta: { displayName: 'Tickets' },
      components: { default: TicketList }
    },
    {
      path: '/bookings/requests',
      name: 'Booking Requests',
      meta: { displayName: 'Requests' },
      components: { default: BookingRequests }
    },
    {
      path: '/bookings/request-forms',
      name: 'Request Forms',
      meta: { displayName: 'Request forms' },
      components: { default: RequestFormsList }
    },
    {
      path: '/bookings/request-forms/:id',
      name: 'Request Form Editor',
      meta: { displayName: 'Request form' },
      components: { default: RequestFormEditor }
    },
    {
      path: '/bookings/calendar',
      name: 'Booking Calendar',
      meta: { displayName: 'Bookings' },
      components: { default: BookingSlots }
    },
    {
      path: '/bookings/resource-calendar',
      name: 'Resource Calendar',
      meta: { displayName: 'Bookings', hideFooter: true },
      components: { default: ResourceCalendarPage }
    },
    {
      path: '/bookings/kanban',
      name: 'Kanban Board',
      meta: { displayName: 'Bookings', hideFooter: true },
      components: { default: KanbanPage }
    },
    {
      path: '/bookings/schedules',
      name: 'Schedules',
      meta: { displayName: 'Schedules' },
      components: { default: ScheduleList }
    },
    {
      path: '/bookings/schedules/create',
      name: 'Create Schedule',
      meta: { displayName: 'Schedules' },
      components: { default: CreateSchedule }
    },
    {
      path: '/bookings/schedules/edit',
      name: 'Edit Schedule',
      meta: { displayName: 'Schedules' },
      components: { default: EditSchedule }
    },
    {
      path: '/bookings/settings/list',
      name: 'Booking Site Settings List',
      meta: { displayName: 'Booking site templates' },
      components: { default: BookingSiteSettingsList }
    },
    {
      path: '/bookings/settings/editor',
      name: 'Booking Site Template Editor',
      meta: { displayName: 'Template editor' },
      components: { default: BookingSiteTemplateEditor }
    }
  ]
};

let purchasesMenu = {
  path: '/purchases',
  component: DashboardLayout,
  redirect: '/purchases/transactions?count=10&page=1',
  name: 'Purchases',
  meta: { requiresAuth: true, displayName: 'Purchases' },
  children: [
    {
      path: '/purchases/transactions',
      name: 'Transactions',
      meta: { displayName: 'Transactions' },
      components: { default: Transactions }
    },
    {
      path: '/purchases/payments',
      name: 'Payments',
      meta: { displayName: 'Payments' },
      components: { default: PaymentList }
    },
    {
      path: '/purchases/gift-cards',
      name: 'Gift Cards',
      meta: { displayName: 'Gift Cards' },
      components: { default: GiftCards }
    },
    {
      path: '/purchases/gift-cards/settings',
      name: 'Gift Card Types',
      meta: { displayName: 'Gift Cards' },
      components: { default: GiftCardType }
    },
    {
      path: '/purchases/passes',
      name: 'Passes',
      meta: { displayName: 'Passes' },
      // Limited beta — block direct URL access for non-beta companies.
      // See src/util/passesBeta.js for the allowlist.
      beforeEnter: (to, from, next) => { isPassesBetaCompany() ? next() : next('/'); },
      components: { default: Passes }
    },
    {
      path: '/purchases/transactions/details',
      name: 'Transaction Details',
      meta: { displayName: 'Transaction Details' },
      components: { default: TransactionDetails }
    },
    {
      path: '/purchases/promos',
      name: 'Promo Codes',
      meta: { displayName: 'Promo Codes' },
      components: { default: PromoCodes }
    },
    {
      path: '/purchases/settings',
      name: 'Payment Settings',
      meta: { displayName: 'Payment Settings' },
      components: { default: PaymentGateways }
    },
    {
      path: '/purchases/point-of-sale',
      name: 'Point of Sale',
      meta: { displayName: 'Point of sale' },
      // Block direct URL access for users without the POS permission —
      // the page's API calls all require it. See src/util/posBeta.js.
      beforeEnter: (to, from, next) => { canConfigurePos() ? next() : next('/'); },
      components: { default: PaymentPagesList }
    },
    {
      path: '/purchases/point-of-sale/:id',
      name: 'Point of Sale Editor',
      meta: { displayName: 'Edit POS page' },
      beforeEnter: (to, from, next) => { canConfigurePos() ? next() : next('/'); },
      components: { default: PaymentPageEditor }
    },
    {
      path: '/purchases/carts',
      name: 'Carts',
      meta: { displayName: 'Carts' },
      components: { default: ActiveCarts }
    },
    {
      path: '/purchases/inventory',
      name: 'Inventory',
      meta: { displayName: 'Inventory' },
      components: { default: InventoryManagement }
    },
  ]
};

let marketingMenu = {
  path: '/marketing',
  component: DashboardLayout,
  redirect: '/marketing/affiliates',
  name: 'Marketing',
  meta: { requiresAuth: true, displayName: 'Marketing' },
  children: [
    {
      path: '/marketing/affiliates',
      name: 'Affiliates',
      meta: { displayName: 'Affiliates' },
      // Limited beta — block direct URL access for non-beta companies.
      // See src/util/affiliatesBeta.js for the allowlist.
      beforeEnter: (to, from, next) => { isAffiliatesBetaCompany() ? next() : next('/'); },
      components: { default: Affiliates }
    },
    {
      path: '/marketing/campaigns/new',
      name: 'Email Campaign Create',
      beforeEnter: (to, from, next) => { isCampaignsBetaCompany() ? next() : next('/'); },
      meta: { displayName: 'Campaigns' },
      components: { default: EditCampaign }
    },
    {
      path: '/marketing/campaigns/:id/report',
      name: 'Email Campaign Report',
      beforeEnter: (to, from, next) => { isCampaignsBetaCompany() ? next() : next('/'); },
      meta: { displayName: 'Campaigns' },
      components: { default: CampaignReport }
    },
    {
      path: '/marketing/campaigns/:id',
      name: 'Email Campaign Edit',
      beforeEnter: (to, from, next) => { isCampaignsBetaCompany() ? next() : next('/'); },
      meta: { displayName: 'Campaigns' },
      components: { default: EditCampaign }
    },
    {
      path: '/marketing/campaigns',
      name: 'Email Campaigns',
      beforeEnter: (to, from, next) => { isCampaignsBetaCompany() ? next() : next('/'); },
      meta: { displayName: 'Campaigns' },
      components: { default: Campaigns }
    }
  ]
};

let checklistMenu = {
  path: '/checklists',
  component: DashboardLayout,
  redirect: '/checklists/new',
  name: 'Checklists',
  meta: { requiresAuth: true, displayName: 'Checklists' },
  children: [
    {
      path: 'settings',
      name: 'Create Checklist',
      meta: { displayName: 'Checklists' },
      components: { default: ChecklistEditor }
    },
    {
      path: 'edit',
      name: 'Edit Checklist',
      meta: { displayName: 'Checklists' },
      components: { default: ChecklistEditor }
    },
    {
      path: 'new',
      name: 'New Checklist',
      meta: { displayName: 'Checklists' },
      components: { default: Checklists }
    },
    {
      path: 'active',
      name: 'Active Checklist',
      meta: { displayName: 'Checklists' },
      components: { default: ActiveChecklist }
    },
    {
      path: 'history',
      name: 'Checklist History',
      meta: { displayName: 'Checklist History' },
      components: { default: ChecklistHistory }
    },
    {
      path: 'history/instance',
      name: 'Checklist details',
      meta: { displayName: 'Checklist history' },
      components: { default: ChecklistInstance }
    },
  ]
}

let gamesMenu = {
  path: '/games',
  component: DashboardLayout,
  redirect: '/games/tracker',
  name: 'Events',
  meta: { requiresAuth: true, displayName: 'Events' },
  children: [
    {
      path: 'tracker/start',
      name: 'Event Tracker Start',
      meta: { displayName: 'Event tracker' },
      components: { default: StartNewForm }
    },
    {
      path: 'tracker/select',
      name: 'Event Tracker Select',
      meta: { displayName: 'Event tracker' },
      components: { default: GameTrackerSelect }
    },
    {
      path: 'tracker/settings',
      name: 'Event Tracker Settings',
      meta: { displayName: 'Event tracker settings' },
      components: { default: GameTrackerSettingsTemplate }
    },
    {
      path: 'tracker',
      name: 'Event Tracker',
      meta: { displayName: 'Event tracker' },
      components: { default: GameTracker }
    },
    // {
    //   path: 'tracker/v2',
    //   name: 'Game Tracker V2',
    //   meta: { displayName: 'Game Tracker V2' },
    //   components: { default: GameTrackerLive }
    // },
    // {
    //   path: 'tracker/v2/:draftId',
    //   name: 'Game Tracker V2 Edit',
    //   meta: { displayName: 'Game Tracker V2' },
    //   components: { default: GameTrackerLive }
    // },
    {
      path: 'settings',
      name: 'Event Settings',
      meta: { displayName: 'Event settings' },
      components: { default: GameSetup }
    },
    {
      path: 'edit',
      name: 'Edit Event',
      meta: { displayName: 'Event settings' },
      components: { default: EditGame }
    },
    {
      path: 'history',
      name: 'Event History',
      meta: { displayName: 'Event history' },
      components: { default: GameInstances }
    },
    {
      path: 'history/instance',
      name: 'Event Data',
      meta: { displayName: 'Event history' },
      components: { default: GameInstance }
    },
    {
      path: 'clues',
      name: 'Hints',
      meta: { displayName: 'Hints' },
      components: { default: Clues }
    },
    {
      path: 'clues/select',
      name: 'Select Event',
      meta: { displayName: 'Hints' },
      components: { default: GameSelectGMView }
    },
    {
      path: 'clues/configure',
      name: 'Configure Hints',
      meta: { displayName: 'Hints' },
      components: { default: ConfigureClues }
    },
    {
      path: 'clues/configure/display',
      name: 'Configure Display',
      meta: { displayName: 'Hints' },
      components: { default: DisplayConfiguration }
    },
    {
      path: 'clues/history',
      name: 'Hint History',
      meta: { displayName: 'Hints' },
      components: { default: ClueHistory }
    },
  ]
};

let mailMenu = {
  path: '/mail',
  component: DashboardLayout,
  redirect: '/mail/contacts',
  name: 'Mail',
  meta: { requiresAuth: true, displayName: 'Emails' },
  children: [
    {
      path: '/mail/automated/settings',
      name: 'Simple Emails',
      meta: { displayName: 'Simple Emails' },
      components: { default: AutomatedEmails }
    },
    {
      path: '/mail/settings',
      name: 'Simple Emails',
      meta: { displayName: 'Email Settings' },
      components: { default: EmailDomainSettings }
    },
    {
      path: '/sms/settings',
      beforeEnter: (to, from, next) => { isSmsBetaCompany() ? next() : next('/'); },
      name: 'SMS Settings',
      meta: { displayName: 'SMS settings' },
      components: { default: SMSSettings }
    },
    {
      path: '/mail/messages',
      name: 'Messages',
      meta: { displayName: 'Messages' },
      components: { default: MessagingLogs }
    },
    {
      path: '/mail/custom/landing',
      name: 'Advanced Emails Landing',
      meta: { displayName: 'Templates and automation' },
      components: { default: CustomEmailLanding }
    },
    {
      path: '/mail/custom/template-types',
      name: 'Advanced Email Template Types',
      meta: { displayName: 'Templates and automation' },
      components: { default: EmailTemplateTypes }
    },
    {
      path: '/mail/custom/template/:id',
      name: 'Advanced Email Template Editor Edit',
      meta: { displayName: 'Templates and automation' },
      components: { default: EmailTemplateBuilder }
    },
    {
      path: '/mail/custom/template',
      name: 'Advanced Email Template Editor Create',
      meta: { displayName: 'Templates and automation' },
      components: { default: EmailTemplateBuilder }
    },
    {
      path: '/mail/custom/automation/:id',
      name: 'Advanced Email Automation Editor Edit',
      meta: { displayName: 'Templates and automation' },
      components: { default: EmailAutomationBuilder }
    },
    {
      path: '/mail/custom/automation',
      name: 'Advanced Email Automation Editor Create',
      meta: { displayName: 'Templates and automation' },
      components: { default: EmailAutomationBuilder }
    }
  ]
};

let photosMenu = {
  path: '/photos',
  component: DashboardLayout,
  redirect: '/photos/new',
  name: 'Photos',
  meta: { requiresAuth: true, displayName: 'Photos' },
  children: [
    {
      path: 'new',
      name: 'Take Photos',
      meta: { displayName: 'Photos' },
      components: { default: TakePhotos }
    },
    {
      path: 'settings/',
      name: 'Photo Settings',
      meta: { displayName: 'Photo Settings' },
      components: { default: PhotoSettingsTemplate }
    },
    {
      path: 'overlays',
      name: 'Photo Overlays',
      meta: { displayName: 'Photo Settings' },
      components: { default: PhotoOverlays }
    }
  ]
};

let waiverMenu = {
  path: '/waivers',
  component: DashboardLayout,
  redirect: '/waivers/history',
  name: 'Waiver',
  meta: { requiresAuth: true, displayName: 'Waivers' },
  children: [
    {
      path: 'history',
      name: 'Waiver History',
      meta: { displayName: 'Waivers' },
      components: { default: Waivers }
    },
    {
      path: 'types',
      name: 'Waivers Types',
      meta: { displayName: 'Waivers' },
      components: { default: WaiverConfigurationList }
    },
    {
      path: 'settings',
      name: 'Waivers',
      meta: { displayName: 'Waivers' },
      components: { default: WaiverTemplate }
    }
  ]
};

let playerMenu = {
  path: '/customers',
  component: DashboardLayout,
  redirect: '/customers/all',
  name: 'Customers',
  meta: { requiresAuth: true, displayName: 'Customers' },
  children: [
    {
      path: 'details',
      name: 'Customer Details',
      meta: { displayName: 'Customers' },
      components: { default: PlayerInfo }
    },
    {
      path: 'all',
      name: 'All Customers',
      meta: { displayName: 'Customers' },
      components: { default: Players }
    }
  ]
};

let surveysMenu = {
  path: '/surveys',
  component: DashboardLayout,
  redirect: '/surveys',
  name: 'Surveys',
  meta: { requiresAuth: true, displayName: 'Surveys' },
  children: [
    {
      path: '/surveys/view',
      name: 'View Surveys',
      meta: { displayName: 'Surveys' },
      components: { default: Surveys }
    },
    {
      path: '/surveys/edit',
      name: 'Edit Surveys',
      meta: { displayName: 'Surveys' },
      components: { default: EditSurvey }
    },
    {
      path: '/surveys/results',
      name: 'Survey Results',
      meta: { displayName: 'Surveys' },
      components: { default: SurveyHistory }
    },
    {
      path: '/surveys/history/response',
      name: 'Survey Responses',
      meta: { displayName: 'Surveys' },
      components: { default: SurveyResponse }
    },
    {
      path: '/surveys/history/question',
      name: 'Survey Questions',
      meta: { displayName: 'Surveys' },
      components: { default: SurveyQuestionResponses }
    }
  ]
};

let settingsMenu = {
  path: '/settings',
  component: DashboardLayout,
  redirect: '/settings/profile',
  name: 'Settings',
  meta: { requiresAuth: true, displayName: 'Settings' },
  children: [
    {
      path: 'user-management',
      name: 'User Management',
      meta: { displayName: 'User Management' },
      components: { default: UserManagement }
    },
    {
      // Legacy invite page; the form is now a drawer on the users list.
      path: 'user-invite',
      redirect: { path: '/settings/user-management', query: { invite: '1' } }
    },
    {
      path: 'roles',
      name: 'User Roles',
      meta: { displayName: 'User Management' },
      components: { default: UserRoles }
    },
    {
      path: 'roles/edit',
      name: 'Edit Role',
      meta: { displayName: 'User Management' },
      components: { default: EditRole }
    },
    {
      path: 'company',
      name: 'Company Settings',
      meta: { displayName: 'Company Settings' },
      components: { default: CompanySettings }
    },
    {
      path: 'group',
      name: 'Company Group Settings',
      meta: { displayName: 'Company Settings' },
      components: { default: GroupSettings }
    },
    {
      path: 'profile',
      name: 'My Profile',
      meta: { displayName: 'My Profile' },
      components: { default: MyProfile }
    },
    {
      // Legacy page; deactivated users are a status filter on the users list.
      path: 'deactivated-users',
      redirect: { path: '/settings/user-management', query: { status: 'deactivated' } }
    },
    {
      path: 'migration',
      name: 'Data Migration',
      meta: { displayName: 'Migrations' },
      components: { default: Migration }
    },
    {
      path: 'migration/log',
      name: 'Data Migration Log',
      meta: { displayName: 'Migrations' },
      components: { default: MigrationLog }
    },
    {
      path: 'billing',
      name: 'Billing',
      meta: { displayName: 'Billing' },
      components: { default: BillingPage }
    },
    {
      path: 'custom-fields',
      name: 'Custom Fields',
      meta: { displayName: 'Custom fields and tags' },
      components: { default: CustomFieldsLibrary }
    },
    {
      path: 'logs',
      name: 'Event Logs',
      meta: { displayName: 'Event Logs' },
      components: { default: EventLogs }
    },
    {
      path: 'api-requests',
      name: 'API Requests',
      meta: { displayName: 'API requests' },
      components: { default: ApiRequests }
    },
  ]
};

let betasMenu = {
  path: '/roadmap',
  component: DashboardLayout,
  name: 'Roadmap',
  meta: { requiresAuth: true, displayName: 'Product roadmap' },
  children: [
    {
      path: '/',
      name: 'Product roadmap',
      meta: { displayName: 'Product roadmap' },
      components: { default: Changelog }
    },
    {
      path: '/roadmap/ticket',
      name: 'Product roadmap ticket',
      meta: { displayName: 'Product roadmap' },
      components: { default: TicketDetails }
    },
    {
      path: '/roadmap/legacy',
      name: 'Legacy changelog',
      meta: { displayName: 'Product roadmap' },
      components: { default: ChangelogLegacy }
    },
    {
      path: '/wizard',
      name: 'Setup wizard',
      meta: { displayName: 'Setup wizard' },
      components: { default: OnboardingWizard }
    }
  ]
};

let projectsMenu = {
  path: '/projects',
  component: DashboardLayout,
  redirect: '/projects',
  name: 'Projects',
  meta: { requiresAuth: true, displayName: 'Projects' },
  children: [
    {
      path: '/projects',
      name: 'ProjectList',
      meta: { displayName: 'Project Management' },
      components: { default: ProjectList }
    },
    {
      path: '/projects/:id',
      name: 'ProjectDetails',
      meta: { displayName: 'Project Management' },
      components: { default: ProjectDetails }
    },
    {
      path: '/projects/:id/tickets/:ticket_id',
      name: 'ProjectTicket',
      meta: { displayName: 'Project Management' },
      components: { default: ProjectTicket }
    },
    {
      path: '/time-tracker/logs',
      name: 'TimeTrackerLogs',
      meta: { displayName: 'Time Tracker' },
      components: { default: TimeTrackerLogs }
    }
  ]
};

let announcementsMenu = {
  path: '/announcements',
  component: DashboardLayout,
  redirect: '/announcements/list',
  name: 'Announcements',
  meta: { requiresAuth: true, displayName: 'Announcements' },
  children: [
    {
      path: '/announcements/list',
      name: 'Announcement List',
      meta: { displayName: 'Announcements' },
      components: { default: AnnouncementsPage }
    }
  ]
};

const routes = [
  {
    path: '/',
    // Entering the app at the bare domain with an existing session lands where a fresh
    // login would (role, then group landing page, then bookings). In-app pushes to '/'
    // stay on the profile page: pages use '/' as the safe fallback after a 401, and
    // resolving those to the landing page could bounce a user back onto the page that
    // just denied them.
    beforeEnter: (to, from, next) => {
      next(from.matched.length ? '/settings/profile' : resolveHomePath())
    },
    name: 'Home',
    meta: { requiresAuth: true, displayName: 'Home' }
  },
  {
    path: '/email/preview',
    name: 'Preview Email',
    components: { default: PreviewEmail },
    meta: { requiresAuth: true, displayName: 'Preview Email' }
  },
  {
    path: '/clues/display',
    name: 'ClueDisplay',
    components: { default: ClueDisplay },
    meta: { requiresAuth: false, displayName: 'Clue Display' }
  },
  {
    path: '/clues/select',
    name: 'GameSelect',
    components: { default: GameSelect },
    meta: { requiresAuth: true, displayName: 'Game Select' }
  },
  {
    path: '/dashboard/game/leaderboard/fullscreen',
    name: 'Leaderboard Fullscreen',
    components: { default: Leaderboard },
    meta: { requiresAuth: true, displayName: 'Leaderboard' }
  },
  {
    path: '/dashboards/fullscreen',
    name: 'Dashboards Fullscreen',
    components: { default: DashboardDisplay },
    meta: { requiresAuth: true, displayName: 'Dashboards' }
  },
  dashboardMenu,
  bookingsMenu,
  purchasesMenu,
  marketingMenu,
  gamesMenu,
  settingsMenu,
  surveysMenu,
  mailMenu,
  waiverMenu,
  photosMenu,
  authPages,
  betasMenu,
  playerMenu,
  checklistMenu,
  projectsMenu,
  announcementsMenu,
  { path: '/forbidden', component: Unauthorized },
  { path: '*', component: NotFound }
];

export default routes;
